import React, { Component } from 'react';
import classnames from 'classnames';
import { withSnackbar } from 'notistack';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
	setAlertActionCreator,
} from 'plugins/store/reducers/common.reducer';
import {
	getRecipientList,
	uploadRecipientList,
} from 'services/threshold.service';
import ValidationDialog from './ValidationDialog';
import withStyles from '@material-ui/core/styles/withStyles';

import SnackMessage from 'components/Snackbar/SnackMessage';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import CsvUpload from 'components/CustomUpload/CsvUpload';
import CustomPhoneLabel from 'components/CustomPhoneLabel/CustomPhoneLabel';

import { thresholdsRecipientListStyles as styles } from 'assets/jss/material-dashboard-pro-react/views/thresholdsStyles';

class ThresholdsRecipientList extends Component {
	state = {
		isLoading: false,
		recipientList: [],
	};

	componentDidMount() {
		this.getRecipientList();
	}

	showToastMessage = (message, color = 'danger') => {
		this.props.enqueueSnackbar(message, {
			content: (key, message) => <SnackMessage id={key} message={message} color={color} />,
		});
	};

	getRecipientList = async () => {
		this.setState({ isLoading: true });
		try {
			const recipientList = await getRecipientList();
			this.setState({ recipientList });
		} catch (error) {
			this.showToastMessage(error.resolvedErrorMessage);
		}
		this.setState({ isLoading: false });
	};

	onCsvLoad = async (file) => {
		this.setState({ isLoading: true });
		try {
			const result = await uploadRecipientList(file);

			const {
				totalEmailsCount,
				totalPhonesCount,
				addedEmailsCount,
				addedPhonesCount,
			} = result;

			if (totalEmailsCount !== addedEmailsCount || totalPhonesCount !== addedPhonesCount) {
				this.openValidationDialog(result);
			} else {
				this.showToastMessage('Thresholds Recipient List has been updated successfully!', 'success');
			}
			this.getRecipientList();
		} catch (error) {
			this.showToastMessage(error.resolvedErrorMessage);
		}
		this.setState({ isLoading: false });
	};

	openValidationDialog = (props) => {
		this.props.setAlert({
			type: 'scrollable',
			maxWidth: 'xs',
			children: <ValidationDialog {...props} />,
			onConfirm: () =>	this.props.setAlert(null),
		});
	};

	render() {
		const { classes } = this.props;
		const loadingIndicator = this.state.isLoading ? (
			<div className={classes.loadingIndicatorWrapper}>
				<LoadingIndicator />
			</div>
		) : null;
		const noResultsFoundText =
			!this.state.isLoading && this.state.recipientList.length === 0 ? (
				<div className={classes.noResultsFound}>No Results Found</div>
			) : null;

		return (
			<div className={classes.wrapper}>
				<div>
					<CsvUpload
						onLoad={this.onCsvLoad}
						label="Upload List of Recipients"
						dialogTitle="Upload List of Recipients"
					/>
					<div className={classes.uploadCsvInfo}>
						Please, upload .csv File with the List of Recipients. First Column should contain Phone Numbers, second Column - e-mails.
					</div>
				</div>
				{loadingIndicator}
				<div className="ReactTable -striped -highlight">
					<table className="rt-table">
						<thead className="rt-thead -header">
							<tr className={classnames('rt-tr', classes.tr)}>
								<th
									className={classnames(
										'rt-th rt-resizable-header',
										classes.th
									)}
								>
									Phone number
								</th>
								<th
									className={classnames(
										'rt-th rt-resizable-header',
										classes.th
									)}
								>
									E-mail
								</th>
							</tr>
						</thead>
						<tbody className="rt-tbody">
							{this.state.recipientList.map(
								({ email, phoneNumber }, index) => (
									<tr
										key={index}
										className={classnames(
											'rt-tr',
											classes.tr,
											{ ' -odd': index % 2 === 0 },
											{ ' -even': index % 2 === 1 }
										)}
									>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{phoneNumber && (
												<CustomPhoneLabel
													key={phoneNumber}
													value={phoneNumber}
												/>
											)}
										</td>
										<td
											className={classnames(
												'rt-td',
												classes.td
											)}
										>
											{email}
										</td>
									</tr>
								)
							)}
						</tbody>
					</table>
				</div>
				{noResultsFoundText}
			</div>
		);
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setAlert: (dialog) => dispatch(setAlertActionCreator(dialog)),
});

export default compose(
	withStyles(styles),
	withSnackbar,
	connect(mapStateToProps, mapDispatchToProps),
)(ThresholdsRecipientList);
